

let _setPostLoginUrl = () => {};
const setPostLoginUrl = (...args) => {
  return _setPostLoginUrl(...args);
};
const setSetPostLoginUrl = (fn) => {
  _setPostLoginUrl = fn;
};

export default {
  setPostLoginUrl,
  setSetPostLoginUrl,
};
